import { LocalStorage } from 'quasar';

export async function flush({ commit, dispatch }) {
  commit('flush');
  dispatch('vehicle/flush', null, { root: true });
}

export async function loadConfig({ commit }) {
  const location = await LocalStorage.getItem('CHECKIT_KIOSK_LOCATION');
  const terminalId = await LocalStorage.getItem('CHECKIT_KIOSK_TERMINAL_ID');

  const config = {
    location,
    terminalId,
  };

  commit('setConfig', { config });
}

export function setConfig(context, { location, terminalId }) {
  LocalStorage.set('CHECKIT_KIOSK_LOCATION', location);
  LocalStorage.set('CHECKIT_KIOSK_TERMINAL_ID', terminalId);
}
